import capitalize from 'lodash/capitalize';
import trimStart from 'lodash/trimStart';

export default name => {
  if (!name) return name;

  return trimStart(name)
    .split(' ')
    .map(word => capitalize(word))
    .join(' ');
};



// WEBPACK FOOTER //
// ./src/components/Program/beautifyName.js